export const MAP_THEMES = {
  OSM: "osm",
  NORDIC_DARK: "nordic-dark",
  ANTIQUE_PARCHMENT: "antique-parchment",
  SATELLITE: "satellite",
  MINIMAL_POSITRON: "minimal-positron",
};

export const ALLOWLISTED_TILE_DOMAINS = [
  "tile.openstreetmap.org",
  "basemaps.cartocdn.com",
  "server.arcgisonline.com",
  "cache.kartverket.no",
];

export const isValidTileUrl = (url) => {
  if (!url || typeof url !== "string") return false;
  if (!url.startsWith("https://")) return false;
  if (/javascript:|data:|vbscript:/i.test(url)) {
    return false;
  }
  try {
    const testUrl = url.replace(/\{[xyzr]\}/g, "0");
    const parsed = new URL(testUrl);
    if (parsed.protocol !== "https:") return false;
    return ALLOWLISTED_TILE_DOMAINS.includes(parsed.hostname);
  } catch {
    return false;
  }
};

const THEME_CONFIGS = {
  [MAP_THEMES.OSM]: {
    id: "osm",
    name: "Standard OpenStreetMap",
    tileUrl: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    routeColor: "#1814E6",
    haloColor: "rgba(24, 20, 230, 0.3)",
    defaultCompassRose: false,
    cssFilter: "",
  },
  [MAP_THEMES.NORDIC_DARK]: {
    id: "nordic-dark",
    name: "Nordisk Natt",
    tileUrl: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    routeColor: "#F59E0B",
    haloColor: "rgba(245, 158, 11, 0.45)",
    defaultCompassRose: false,
    cssFilter: "invert(0.92) hue-rotate(185deg) saturate(0.65) brightness(0.88) contrast(1.12)",
  },
  [MAP_THEMES.ANTIQUE_PARCHMENT]: {
    id: "antique-parchment",
    name: "Antikk Pergament",
    tileUrl: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    routeColor: "#8B1E0F",
    haloColor: "rgba(139, 30, 15, 0.35)",
    defaultCompassRose: true,
    cssFilter: "sepia(0.68) contrast(1.08) brightness(0.92) saturate(0.75) hue-rotate(-12deg)",
  },
  [MAP_THEMES.SATELLITE]: {
    id: "satellite",
    name: "Satellitt",
    tileUrl: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    routeColor: "#38BDF8",
    haloColor: "rgba(56, 189, 248, 0.45)",
    defaultCompassRose: false,
    cssFilter: "contrast(1.05)",
  },
  [MAP_THEMES.MINIMAL_POSITRON]: {
    id: "minimal-positron",
    name: "Minimalistisk Lys",
    tileUrl: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    routeColor: "#0F172A",
    haloColor: "rgba(15, 23, 42, 0.3)",
    defaultCompassRose: false,
    cssFilter: "grayscale(0.88) brightness(1.06) contrast(0.95)",
  },
};

export const getMapThemeConfig = (themeId) => {
  if (themeId && THEME_CONFIGS[themeId]) {
    return { ...THEME_CONFIGS[themeId] };
  }
  return { ...THEME_CONFIGS[MAP_THEMES.OSM] };
};
